<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-richwater">
      <div class="px-3 col-3 p-0">
        <div class="heading-richwater">{{ $t('result.round') }}</div>
        <div class="text-subhead">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-richwater">{{ $t('result.bet') + `${currency}` }}</div>
        <div class="text-subhead">{{ data.count === 0
          ? data.bet
          : data.detail.summary[data.count].bet.amount | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-richwater">{{ $t('result.winlose') + `${currency}` }}</div>
        <div class="text-subhead"> {{ winlose | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-richwater">{{ $t('result.balance') + `${currency}` }}</div>
        <div class="text-subhead">{{ balance | currencyFormatter }}</div>
      </div>
    </div>
    <div class="content-result-richwater pt-3">
      <div class="text-game-richwater">{{ 'Rich Rich Water' }}</div>
      <div class="text-subgame">{{ $t('richwater.name') }}</div>
      <div class="text-date-richwater mb-1">{{ data.timestamp }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0">
        <div class="col-1 d-flex align-items-center justify-content-center" style="color: white">
          <i v-if="isFreespin || isRespin" class="fas fa-caret-left arrow-side-richwater" @click="delCount()"></i>
        </div>
        <div class="container d-flex flex-column justify-content-center table-richwater table-richWater">
          <table>
            <tbody>
              <tr v-for="(row, index) in table" :key="index">
                <td class="p-0" v-for="(col, i) in row" :key="`${index}${i}`">
                  <img class="icon-symbol-richwater"
                    :src="require(`../../assets/resultGame/richWater/symbol_${col}.png`)" alt="">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!isEndRound" class="fas fa-caret-right arrow-side-richwater" @click="addCount()"></i>
        </div>
      </div>
      <div v-if="isFreespin" class="text-subgame mb-1">{{ $t('result.freespin') + ' ' + result.freeSpinsPlayed +
        '/' + result.freeSpinsCount }}</div>
      <div v-if="isFreespin" class="text-game-richwater">{{ $t('result.multiplier') + ' ' + 'x' +
        result.freeSpinsCurrentMultiplier }}</div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <div class="col-2"></div>
        <hr class="line">
        <div class="text-detail align-items-center d-flex px-3">{{ $t('result.detail') }}</div>
        <hr class="line">
        <div class="col-2"></div>
      </div>
      <div v-if="result.featureBuy" class="text-subgame-richwater">Feature Buy</div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4">
        <div class="bet-box-richwater p-2 px-3">
          <div class="bet-warpper-richwater item" v-for="(detail, index) in result.winCombos" :key="index">
            <div class="d-flex item justify-content-between px-1 mb-2">
              <div class="bet-wrapper-richwater item">
                <div class="d-flex justify-content-start bet-wrapper item">
                  <img class="icon-detail-richwater p-2"
                    :src="require(`../../assets/resultGame/richWater/symbol_${detail[0]}.png`)" alt="">
                  <div class="d-flex flex-column align-items-start justify-content-center">
                    <p class="my-1" style="color: #cb1818">{{ `${detail[1]} ` + $t('result.kind') }}</p>
                  </div>
                  <div class="d-flex flex-column justify-content-center px-3">
                    <p class="my-1">{{ currency }} {{ (isFreespin
                      ? (result.freeSpinsCurrentMultiplier === 0
                        ? (result.winnings[index] * 1)
                        : (result.winnings[index] * result.freeSpinsCurrentMultiplier))
                      : (result.winnings[index])
                    ) | currencyFormatter }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bet-warpper-richwater item" v-if="result.winShowsCount === 0">
            <div class="d-flex justify-content-between mt-5">
              <div class="bet-wrapper-richwater item align-content-center d-flex">
                <div class="d-flex justify-content-center bet-wrapper item align-content-center p-3">
                  <p class="my-1 red">{{ 'No Winnings' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../services/utils'
export default {
  name: 'result-่richwater',
  props: {
    data: Object,
  },
  data() {
    return {
      headerHeight: null,
      table: [
        [1, 5, 9, 13, 17,],
        [2, 6, 10, 14, 18,],
        [3, 7, 11, 15, 19,],
        [4, 8, 12, 16, 20,],
      ],
      dateTimeFormatter: function formatter(date) { return utils.dateTimeFormatter(date) },
      tokenData: utils.getTokenData(this.$route.query.t),
      date: '',
      time: '',
      result: this.data,
      count: this.data.count,
      currency: this.data.currency ? this.data.currency : 'THB',
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
    }
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName('header')[0].offsetHeight
    },
    mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.result = result;
      this.isEndRound = result.isEndRound;
      this.winnings = result.winnings;
      this.freeSpinsCurrentMultiplier = result.freeSpinsCurrentMultiplier;
      this.isFreespin =
        result.state === "FREESPIN" ||
        result.state === "FREERESPIN";
      this.isRespin = result.state === "RESPIN";
      this.winlose = result.win;
      this.bet = result.bet;
      this.balance = result.balance;
      if (this.isFreespin) {
        const reel1 = this.data.game.config.freeGameReel1
        const reel2 = this.data.game.config.freeGameReel2
        const reel3 = this.data.game.config.freeGameReel3
        const reel4 = this.data.game.config.freeGameReel4
        const reel5 = this.data.game.config.freeGameReel5

        const indexReel1 = result.freeReelStopIndexes[0]
        const indexReel2 = result.freeReelStopIndexes[1]
        const indexReel3 = result.freeReelStopIndexes[2]
        const indexReel4 = result.freeReelStopIndexes[3]
        const indexReel5 = result.freeReelStopIndexes[4]

        this.table[0][0] = reel1[indexReel1]
        this.table[1][0] = reel1[indexReel1 + 1] === undefined ? reel1[0] : reel1[indexReel1 + 1]
        this.table[2][0] = reel1[indexReel1 + 2] === undefined ? indexReel1 + 2 === reel1.length ? reel1[0] : reel1[1] : reel1[indexReel1 + 2]
        this.table[3][0] = reel1[indexReel1 + 3] === undefined ?
          indexReel1 + 3 === reel1.length ? reel1[0]
            : indexReel1 + 3 === reel1.length + 1 ? reel1[1]
              : reel1[2] : reel1[indexReel1 + 3]

        this.table[0][1] = reel2[indexReel2]
        this.table[1][1] = reel2[indexReel2 + 1] === undefined ? reel2[0] : reel2[indexReel2 + 1]
        this.table[2][1] = reel2[indexReel2 + 2] === undefined ? indexReel2 + 2 === reel2.length ? reel2[0] : reel1[1] : reel2[indexReel2 + 2]
        this.table[3][1] = reel2[indexReel2 + 3] === undefined ?
          indexReel2 + 3 === reel2.length ? reel2[0]
            : indexReel2 + 3 === reel2.length + 1 ? reel2[1]
              : reel2[2] : reel2[indexReel2 + 3]

        this.table[0][2] = reel3[indexReel3]
        this.table[1][2] = reel3[indexReel3 + 1] === undefined ? reel3[0] : reel3[indexReel3 + 1]
        this.table[2][2] = reel3[indexReel3 + 2] === undefined ? indexReel3 + 2 === reel3.length ? reel3[0] : reel3[1] : reel3[indexReel3 + 2]
        this.table[3][2] = reel3[indexReel3 + 3] === undefined ?
          indexReel3 + 3 === reel3.length ? reel3[0]
            : indexReel3 + 3 === reel3.length + 1 ? reel3[1]
              : reel3[2] : reel3[indexReel3 + 3]

        this.table[0][3] = reel4[indexReel4]
        this.table[1][3] = reel4[indexReel4 + 1] === undefined ? reel4[0] : reel4[indexReel4 + 1]
        this.table[2][3] = reel4[indexReel4 + 2] === undefined ? indexReel4 + 2 === reel4.length ? reel4[0] : reel4[1] : reel4[indexReel4 + 2]
        this.table[3][3] = reel4[indexReel4 + 3] === undefined ?
          indexReel4 + 3 === reel4.length ? reel4[0]
            : indexReel4 + 3 === reel4.length + 1 ? reel4[1]
              : reel4[2] : reel4[indexReel4 + 3]

        this.table[0][4] = reel5[indexReel5]
        this.table[1][4] = reel5[indexReel5 + 1] === undefined ? reel5[0] : reel5[indexReel5 + 1]
        this.table[2][4] = reel5[indexReel5 + 2] === undefined ? indexReel5 + 2 === reel5.length ? reel5[0] : reel5[1] : reel5[indexReel5 + 2]
        this.table[3][4] = reel5[indexReel5 + 3] === undefined ?
          indexReel5 + 3 === reel5.length ? reel5[0]
            : indexReel5 + 3 === reel5.length + 1 ? reel5[1]
              : reel5[2] : reel5[indexReel5 + 3]
      } else {
        const reel1 = this.data.game.config.baseGameReel1
        const reel2 = this.data.game.config.baseGameReel2
        const reel3 = this.data.game.config.baseGameReel3
        const reel4 = this.data.game.config.baseGameReel4
        const reel5 = this.data.game.config.baseGameReel5

        const indexReel1 = result.baseReelStopIndexes[0]
        const indexReel2 = result.baseReelStopIndexes[1]
        const indexReel3 = result.baseReelStopIndexes[2]
        const indexReel4 = result.baseReelStopIndexes[3]
        const indexReel5 = result.baseReelStopIndexes[4]

        this.table[0][0] = reel1[indexReel1]
        this.table[1][0] = reel1[indexReel1 + 1] === undefined ? reel1[0] : reel1[indexReel1 + 1]
        this.table[2][0] = reel1[indexReel1 + 2] === undefined ? indexReel1 + 2 === reel1.length ? reel1[0] : reel1[1] : reel1[indexReel1 + 2]
        this.table[3][0] = reel1[indexReel1 + 3] === undefined ?
          indexReel1 + 3 === reel1.length ? reel1[0]
            : indexReel1 + 3 === reel1.length + 1 ? reel1[1]
              : reel1[2] : reel1[indexReel1 + 3]

        this.table[0][1] = reel2[indexReel2]
        this.table[1][1] = reel2[indexReel2 + 1] === undefined ? reel2[0] : reel2[indexReel2 + 1]
        this.table[2][1] = reel2[indexReel2 + 2] === undefined ? indexReel2 + 2 === reel2.length ? reel2[0] : reel1[1] : reel2[indexReel2 + 2]
        this.table[3][1] = reel2[indexReel2 + 3] === undefined ?
          indexReel2 + 3 === reel2.length ? reel2[0]
            : indexReel2 + 3 === reel2.length + 1 ? reel2[1]
              : reel2[2] : reel2[indexReel2 + 3]

        this.table[0][2] = reel3[indexReel3]
        this.table[1][2] = reel3[indexReel3 + 1] === undefined ? reel3[0] : reel3[indexReel3 + 1]
        this.table[2][2] = reel3[indexReel3 + 2] === undefined ? indexReel3 + 2 === reel3.length ? reel3[0] : reel3[1] : reel3[indexReel3 + 2]
        this.table[3][2] = reel3[indexReel3 + 3] === undefined ?
          indexReel3 + 3 === reel3.length ? reel3[0]
            : indexReel3 + 3 === reel3.length + 1 ? reel3[1]
              : reel3[2] : reel3[indexReel3 + 3]

        this.table[0][3] = reel4[indexReel4]
        this.table[1][3] = reel4[indexReel4 + 1] === undefined ? reel4[0] : reel4[indexReel4 + 1]
        this.table[2][3] = reel4[indexReel4 + 2] === undefined ? indexReel4 + 2 === reel4.length ? reel4[0] : reel4[1] : reel4[indexReel4 + 2]
        this.table[3][3] = reel4[indexReel4 + 3] === undefined ?
          indexReel4 + 3 === reel4.length ? reel4[0]
            : indexReel4 + 3 === reel4.length + 1 ? reel4[1]
              : reel4[2] : reel4[indexReel4 + 3]

        this.table[0][4] = reel5[indexReel5]
        this.table[1][4] = reel5[indexReel5 + 1] === undefined ? reel5[0] : reel5[indexReel5 + 1]
        this.table[2][4] = reel5[indexReel5 + 2] === undefined ? indexReel5 + 2 === reel5.length ? reel5[0] : reel5[1] : reel5[indexReel5 + 2]
        this.table[3][4] = reel5[indexReel5 + 3] === undefined ?
          indexReel5 + 3 === reel5.length ? reel5[0]
            : indexReel5 + 3 === reel5.length + 1 ? reel5[1]
              : reel5[2] : reel5[indexReel5 + 3]
      }

      if (result.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
  }
}
</script>

<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #292933
    /* margin: 0; */
}

.icon-detail-richwater {
  width: 100px;
  height: 100px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-richwater {
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-richwater:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-richwater {
  background: #20a4a0;
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.table-richWater {
  background: url('~@/assets/resultGame/richWater/slot_frame.png') no-repeat;
}

.bet-wrapper-richwater .item {
  color: #fff;
  /* background: #20a4a0; */
  line-height: 1;
  border-radius: 10px;
  border: 1.5px solid #cac095;
}

.bet-box-richwater .bet-wrapper-richwater:not(:first-child) .item {
  margin-top: 10px;
}

.bet-wrapper-richwater,
.result-wrapper {
  font-size: 35px;
}

.header-richwater {
  background: #20a4a0;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-richwater>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-richwater {
  /* color: #cb1818; */
  text-align: center;
}

.content-result-richwater {
  background: #2ccfbd;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-richwater {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-game-richwater {
  font-size: 25px;
  text-align: center;
}

.text-subgame-richwater {
  font-size: 30px;
  color: #ffffff;
  text-align: center;
}

.text-subhead {
  font-size: px;
  color: white;
  text-align: center;
}

.text-subgame {
  font-size: 20px;
  color: white;
  text-align: center;
}

.text-date-richwater {
  font-size: 20px;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #c7b873;
  text-align: center;
}

.icon-symbol-richwater {
  width: 100%;
}

.bet-box-richwater {
  min-width: 600px;
  max-width: auto;
}

.table-richwater {
  background-size: 500px 440px;
  width: 500px;
  height: 440px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
}

@media screen and (max-width: 1030px) {
  .table-richwater {
    background-size: 450px 400px;
    width: 450px;
    height: 400px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-richwater {
    font-size: 60px;
  }

  .bet-box-richwater {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }

  .bet-wrapper-richwater,
  .result-wrapper {
    font-size: 35px;
  }
}

@media screen and (min-width: 1060px) {

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-richwater,
  .result-wrapper {
    font-size: 33px;
  }

}

.line {
  background-color: #c7b873;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #10b24b;
}

@media screen and (max-width: 770px) {
  .heading-richwater {
    font-size: 18px;
  }

  .table-richwater {
    background-size: 420px 360px;
    width: 420px;
    height: 360;
    margin-bottom: 1%;
    padding-bottom: 35px;
  }

  .text-subhead {
    font-size: 18px;
  }

  .arrow-side-richwater {
    font-size: 50px;
  }

  .bet-box-richwater {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #c7b873;
    text-align: center;
  }

  .icon-detail-richwater {
    width: 80px;
    height: 80px;
  }

}

@media screen and (max-width: 480px) {
  .header-richwater>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-richwater {
    font-size: 12px;
  }

  .table-richwater {
    background-size: 300px 255px;
    width: 300px;
    height: 255px;
    margin-top: 1%;
    padding-top: 1.5rem;
  }

  .text-subhead {
    font-size: 14px;
  }

  .bet-box-richwater {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bet-wrapper-richwater,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-richwater {
    width: 60px;
    height: 60px;
  }
}
</style>